import React from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import Highcharts3D from 'highcharts/highcharts-3d';
import GlobalStyles from '../../styles/theme';

// Initialize the 3D module
Highcharts3D(Highcharts);
const theme = GlobalStyles.palette;

// /* eslint-disable no-bitwise */
// function hexToRGBA(hex, opacity) {
//   const bigint = parseInt(hex.slice(1), 16);
//   const r = (bigint >> 16) & 255;
//   const g = (bigint >> 8) & 255;
//   const b = bigint & 255;
//   return `rgba(${r}, ${g}, ${b}, ${opacity})`;
// }
// /* eslint-enable no-bitwise */

const statusColorMap = {
  FAILED: theme.failed?.main,
  PENDING: theme.pending?.main,
  DRAFT: theme.draft?.main,
  'PARTIAL PAYMENT': theme.partialpayment?.main,
  PAID: theme.paid?.main,
  'OVER DUE': theme.overdue?.main,
  'WRITE OFF': theme.writeoff?.main,
  'MANUAL PAYMENT ': theme.manual?.main
};

function InvoiceChart({ data }) {
  const formattedData = data.map((item) => ({
    ...item,
    color: statusColorMap[item.name]
  }));

  const options = {
    chart: {
      type: 'pie',
      options3d: {
        enabled: true,
        alpha: 45,
        beta: 0
      }
    },
    title: {
      text: 'Invoice Stats'
    },
    accessibility: {
      enabled: false
    },
    tooltip: {
      valueSuffix: ''
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        depth: 35,
        dataLabels: {
          enabled: true,
          format: `<b>{point.name}:</b> {point.y}`
        }
      }
    },
    series: [
      {
        type: 'pie',
        name: 'Invoice Count',
        colorByPoint: true,
        data: formattedData
      }
    ]
  };

  return (
    <Box>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </Box>
  );
}

InvoiceChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      y: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
      // Add other properties expected in the object
    })
  ).isRequired
};

export default InvoiceChart;
